import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Button,
    Grid,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    FormLabel,
    Radio,
    RadioGroup,
    FormControlLabel,
    Divider,
    Backdrop,
    CircularProgress,
    Snackbar
} from '@material-ui/core';
import Page from 'src/components/Page';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'src/utils/axios';
import { useHistory, useLocation } from 'react-router';
import Skeleton from '@mui/material/Skeleton';
import Alert from 'src/components/Alert';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2, 2)
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff',
    },
}));

function IndividualProductInquiry() {
    const classes = useStyles();
    const history = useHistory();

    const [modelCodeInput, setModelCodeInput] = React.useState('');
    const [serialNumberInput, setSerialNumberInput] = React.useState('');
    const [yearInput, setYearInput] = React.useState('');
    const [monthInput, setMonthInput] = React.useState('');

    const [productSearchPopUp, setProductSearchPopUp] = React.useState(false);
    const [searchType, setSearchType] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [loading, setLoading] = React.useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });



    useEffect(() => {
        // Check if coming from a specific page
        const previousPath = localStorage.getItem('previousPath');
        if (previousPath === '/IndividualInquiryReceipts') {
            setModelCodeInput(localStorage.getItem('modelCodeInput') || '');
            setSerialNumberInput(localStorage.getItem('serialNumberInput') || '');
            setYearInput(localStorage.getItem('yearInput') || '');
            setMonthInput(localStorage.getItem('monthInput') || '');
            setSearchType(Number(localStorage.getItem('searchType')) || 1);
            setSelectedProduct(localStorage.getItem('selectedProduct') || null);
        } else {
            clearAllInputs();
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('modelCodeInput', modelCodeInput);
        localStorage.setItem('serialNumberInput', serialNumberInput);
        localStorage.setItem('yearInput', yearInput);
        localStorage.setItem('monthInput', monthInput);
        localStorage.setItem('searchType', searchType);
        localStorage.setItem('selectedProduct', selectedProduct);

        // Save the current page path to local storage for future reference
        localStorage.setItem('previousPath', history.location.pathname);
    }, [modelCodeInput, serialNumberInput, yearInput, monthInput, searchType, selectedProduct]);

    const handleSearch = () => {
        if (searchTerm.length <= 0) {
            setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        const data = {
            SearchType: searchType,
            SearchTerm: searchTerm
        }
        setLoading(true);
        axios.get(`GetModelCodesOfProducts/${data.SearchType}/${data.SearchTerm}`)
            .then((response) => {
                var data = response.data;
                setSearchResults(data);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    };

    const handleSelectProduct = (product) => {
        setModelCodeInput(product.KUL_MODEL_KODU + ' - ' + product.ACIKLAMA);
        setSelectedProduct(product.MODEL_KODU);
        setProductSearchPopUp(false);
        setSearchResults([]);
        setSearchTerm('');
    };

    const sendInformationsOfProduct = () => {
        let ModelCode = selectedProduct;
        let SerialNo = Number(serialNumberInput);
        let UYear = yearInput ? Number(yearInput) : -1;
        let UPeriod = monthInput ? Number(monthInput) : -1;

        if (!ModelCode && !SerialNo) {
            setresponseMessage('Lütfen Model Kodu veya Seri No alanlarını boş bırakmayınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }

        history.push(`/IndividualInquiryReceipts/${UYear}/${UPeriod}/${ModelCode}/${SerialNo}`);
    }

    const clearAllInputs = () => {
        setSelectedProduct(null);
        setModelCodeInput('');
        setSerialNumberInput('');
        setYearInput('');
        setMonthInput('');
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={5000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Grid container spacing={1}>
                <Grid item xs={false} sm={false} md={2} />
                <Grid item xs={12} sm={12} md={8}>
                    <Paper elevation={5}>
                        <Page title={'Tekil Ürün Sorgulama'} style={{ marginTop: '2rem' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Typography
                                        gutterBottom
                                        variant='h4'
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontWeight: 'bold',
                                            marginTop: '1rem'
                                        }}
                                    >
                                        {'Tekil Ürüne Göre Sorgulama (* alanları zorunlu alanlardır.)'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        id="outlined-required"
                                        value={'* Model Kodu'}
                                        size="medium"
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{
                                            style: {
                                                fontWeight: 'bold',
                                                opacity: 1,
                                                color: 'red',
                                                textAlign: 'center',
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        label='Model Kodu'
                                        size="medium"
                                        value={modelCodeInput ? modelCodeInput : ''}
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{
                                            style: {
                                                fontWeight: 'bold',
                                                opacity: 1,
                                                color: 'black',
                                                cursor: 'text'
                                            },
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => { setProductSearchPopUp(true); }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        id="outlined-required"
                                        value={'* Seri No'}
                                        size="medium"
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{
                                            style: {
                                                fontWeight: 'bold',
                                                opacity: 1,
                                                color: 'red',
                                                textAlign: 'center'
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        label='Seri No'
                                        variant='outlined'
                                        value={serialNumberInput}
                                        onChange={(event) => { setSerialNumberInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        id="outlined-required"
                                        value={'Yıl'}
                                        size="medium"
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{
                                            style: {
                                                fontWeight: 'bold',
                                                opacity: 1,
                                                color: 'red',
                                                textAlign: 'center'
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        label='Yıl'
                                        variant='outlined'
                                        value={yearInput}
                                        onChange={(event) => { setYearInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        id="outlined-required"
                                        value={'Ay'}
                                        size="medium"
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{
                                            style: {
                                                fontWeight: 'bold',
                                                opacity: 1,
                                                color: 'red',
                                                textAlign: 'center'
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4}>
                                    <TextField
                                        label='Ay'
                                        variant='outlined'
                                        value={monthInput}
                                        onChange={(event) => { setMonthInput(event.target.value); }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={2} sm={2} md={2} />
                                <Grid item xs={3} sm={3} md={3} />
                                <Grid item xs={3} sm={3} md={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => { sendInformationsOfProduct(); }}
                                        fullWidth
                                        size='large'
                                        style={{ marginTop: '1rem', marginBottom: '1rem' }}
                                    >
                                        GÖNDER
                                    </Button>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size='large'
                                        style={{ marginTop: '1rem', marginBottom: '1rem' }}
                                        onClick={() => { clearAllInputs(); }}
                                    >
                                        TEMİZLE
                                    </Button>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} />
                            </Grid>
                        </Page >
                    </Paper>
                </Grid>
                <Grid item xs={false} sm={false} md={2} />
            </Grid>
            <Dialog
                open={productSearchPopUp}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl>
                                <FormLabel>Arama Türü</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="searchType"
                                    name="searchType"
                                    value={searchType}
                                    onChange={(e) => setSearchType(Number(e.target.value))}
                                >
                                    <FormControlLabel value={1} control={<Radio />} label="Model Koduna göre arama" />
                                    <FormControlLabel value={2} control={<Radio />} label="Açıklamaya göre arama" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                label="Model Arama"
                                fullWidth
                                size='medium'
                                variant='outlined'
                                margin="normal"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Button
                                color='secondary'
                                variant="contained"
                                size='medium'
                                fullWidth
                                onClick={() => { handleSearch(); }}
                            >
                                Arama Yap
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Divider style={{ margin: '1rem' }} />
                            <TableContainer component={Paper}>
                                <Table size='medium'>
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                            <TableCell colSpan={2}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Ürün Listesi
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                align='center'
                                                style={{ border: '1px solid #ddd' }}
                                            >
                                                Model Kodu
                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                Açıklama
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            Array.from(new Array(4)).map((_, index) => (
                                                <TableRow key={index}>
                                                    {Array.from(new Array(2)).map((_, cellIndex) => (
                                                        <TableCell key={cellIndex} colSpan={1}>
                                                            <Skeleton animation="pulse" variant="text" width={300} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : (
                                            searchResults.length > 0 && searchResults.map((result, index) => (
                                                <TableRow key={index} onClick={() => handleSelectProduct(result)} style={{ cursor: 'pointer' }}>
                                                    <TableCell align='center' style={{ border: '1px solid #ddd' }}>{result.KUL_MODEL_KODU}</TableCell>
                                                    <TableCell style={{ border: '1px solid #ddd' }}>{result.ACIKLAMA}</TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <IconButton
                        color="primary"
                        onClick={() => { setProductSearchPopUp(false); setSearchResults([]); setSearchTerm([]); }}
                        aria-label="close"
                        component="span"
                        variant="contained"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default IndividualProductInquiry;
